<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">Registration Agreement</h3>
    <div class="informationBox">
          <p>By creating an account on this website, you agree to the following terms and conditions:</p>
      <ul class="useragreement">
        <li>
          <div class="t1">1. Eligibility</div>
          <p>You must be at least 18 years old or have the consent of a parent or legal guardian to register and use this website.</p>
        </li>
        <li>
          <div class="t1">2. Accurate Information</div>
          <p>You agree to provide true, accurate, current, and complete information during registration and to update such information if it changes.</p>
        </li>
        <li>
          <div class="t1">3. Account Security</div>
          <p >You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</p>
        </li>
        <li>
          <div class="t1">4. Prohibited Use</div>
          <p >You agree not to:</p>
          <div class="t3">
            
            <ul class="agreementList">
              <li>Use false or misleading information </li>
              <li>Create multiple fraudulent accounts  </li>
              <li>Use the website for unlawful purposes </li>
              <li>Interfere with the operation or security of the website </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">5. Approval of Registration</div>
          <p >The company reserves the right to review, approve, reject, suspend, or terminate any registration at its sole discretion.</p>
        </li>
        <li>
          <div class="t1">6. Privacy</div>
          <p >Your personal data will be processed in accordance with our Privacy Policy and applicable GDPR regulations.</p>
        </li>
        <li>
          <div class="t1">7. Account Termination</div>
          <p >We may suspend or close your account if you violate these terms or applicable laws.</p>
        </li>
        <li>
          <div class="t1">8. Changes to Terms</div>
          <p >We reserve the right to update this Registration Agreement at any time. Continued use of the website means acceptance of the updated terms.</p>
        </li>
        <li>
          <div class="t1">9. Governing Law</div>
          <p >This agreement shall be governed by the laws of Germany and applicable EU consumer regulations.</p>
        </li>
        
        
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";
.agreementList li{
  list-style: inside;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/registrationagreement.vue